export default {"src":"/_next/static/media/app-store-ios.9eab4c10.svg","height":14,"width":13,"blurWidth":0,"blurHeight":0};